import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import { PATHS } from "./paths";
import HomePage from "../components/pages/HomePage/HomePage";
import ProfilePage from "../components/pages/ProfilePage/ProfilePage";
import BackendTestPage from "../components/pages/BackendTestPage/BackendTestPage";
import PrivateRouteElement from './PrivateRouteElement/PrivateRouteElement';
import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import LoadingPage from '../components/pages/LoadingPage/LoadingPage';
import GoogleMapsTestPage from '../components/pages/GoogleMapsTestPage/GoogleMapsTestPage';
import MyMediaPage from '../components/pages/MyMediaPage/MyMediaPage';
import FavoritesPage from '../components/pages/FavoritesPage/FavoritesPage';
import PrivacyPolicyPage from '../components/pages/PrivacyPolicyPage/PrivacyPolicyPage';
import AdminRouteElement from './AdminRouteElement/AdminRouteElement';
import ReportsPage from '../components/pages/ReportsPage/ReportsPage';
import ManualWithdrawalsPage from '../components/pages/ManualWithdrawalsPage/ManualWithdrawalsPage';

const Router = () => {
    const { keycloak, initialized } = useKeycloak();

    useEffect(() => {
        if (keycloak && initialized) {
            keycloak.onTokenExpired = () => keycloak.updateToken(600);
        }
        return () => {
            if (keycloak) keycloak.onTokenExpired = () => { };
        };
    }, [initialized, keycloak]);

    if (!initialized) {
        return <LoadingPage />;
    }

    return (
        <Routes>
            <Route exact path={PATHS.root} element={<GoogleMapsTestPage />} />
            <Route exact path={PATHS.gmapst} element={<GoogleMapsTestPage />} />
            <Route exact path={PATHS.profile} element={
                <PrivateRouteElement>
                    <ProfilePage />
                </PrivateRouteElement>
            } />
            <Route exact path={PATHS.mymedia} element={
                <PrivateRouteElement>
                    <MyMediaPage />
                </PrivateRouteElement>
            } />
            <Route exact path={PATHS.favorites} element={
                <PrivateRouteElement>
                    <FavoritesPage />
                </PrivateRouteElement>
            } />
            <Route exact path={PATHS.reports} element={
                <AdminRouteElement>
                    <ReportsPage />
                </AdminRouteElement>
            } />
            <Route exact path={PATHS.manualWithdrawals} element={
                <AdminRouteElement>
                    <ManualWithdrawalsPage />
                </AdminRouteElement>
            } />
            {/* <Route exact path={PATHS.backend} element={
                <PrivateRouteElement>
                    <BackendTestPage/>
                </PrivateRouteElement>
            }/> */}
            <Route exact path={PATHS.accountDelete} element={<Navigate to={PATHS.profile} replace />} />
            <Route exact path={PATHS.privacyPolicy} element={<PrivacyPolicyPage />} />
            <Route path={PATHS.all} element={<Navigate to={PATHS.root} replace />} />
        </Routes>
    );
}

export default Router;